import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  invoicesListHeader: {
    backgroundColor: '#f5f5f5',
    marginHorizontal: -20,
    padding: 20,
    flexDirection: 'row',
    marginBottom: 20,
  },
  payInvoiceHeader: {
    paddingVertical: 20,
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E6EBEE',
    marginBottom: 14,
  },
})

export const toolBarStyles = StyleSheet.create({
  container: {
    padding: 16,
  },
  centeredContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 16,
  },
  title: {
    fontSize: 18,
    fontWeight: '600',
  },
  centeredTitle: {
    color: '#335C75',
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 24,
  },
  filterText: {
    fontSize: 15,
    lineHeight: 21,
    fontWeight: '500',
    color: '#335C75',
  },
  factoringFilter: {
    height: 40,
    alignItems: 'flex-end',
    marginTop: 10,
  },
})
